// extracted by mini-css-extract-plugin
var _1 = "UserDetailPreviewPopOver-module__view--uHXuR";
export { _1 as "view" }
